import React, { useState } from 'react';

import styled from '@emotion/styled';

import { Container } from '@portal/components/shared/layout';
import { Heading } from '@portal/components/shared/text';

import { PasswordEditForm } from './form';

const Title = styled(Heading)`
  text-align: center;
  margin-bottom: 32px;
  @media (max-width: 600px) {
    text-align: left;
    margin-bottom: 16px;
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 470px;
`;

export const Edit: React.FC<{ token: string }> = ({ token }) => {
  const onSave = () => {
    location.replace('/restore');
  };

  return (
    <Container hasNavbar={false}>
      <Title level={1} size="large">
        Choose your new password:
      </Title>
      <Content>
        <PasswordEditForm token={token} onSave={onSave} />
      </Content>
    </Container>
  );
};
Edit.displayName = 'EditPassword';
